















import { Inject, Ref, Prop, Component, Vue } from 'vue-property-decorator'
import { gsap } from 'gsap'
import { cloneDeep } from 'lodash'
import { Branch } from '@/api/model/branch'
import { BranchAPI } from '@/api/backend-client'

@Component
export default class ListTeamsActions extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    @Prop({ required: true }) readonly team!: Branch
    @Ref() wrapper: HTMLDivElement
    visible: boolean = false
    value: Branch = null

    created(): void {
        this.value = cloneDeep<Branch>(this.team)
    }

    animateShow(element: HTMLDivElement, onComplete: () => void) {
        gsap.set(this.wrapper, {
            opacity: 0,
        })

        gsap.to(this.wrapper, {
            duration: .2,
            opacity: 1,
            onComplete,
        })
    }

    animateHide(element: HTMLDivElement, onComplete: () => void) {
        gsap.to(this.wrapper, {
            duration: .2,
            opacity: 0,
            onComplete,
        })
    }

    async deleteTeam(team: Branch): Promise<void> {
        if (confirm(this.$t('company_settings.teams.delete_confirm').toString())) {
            await BranchAPI.delete(team.id)
            await this.reloadCompany()
        }
    }

    async navigateToEdit(team: Branch): Promise<void> {
        await this.$router.push({
            name: 'company_settings_teams_edit',
            params: {
                teamId: team.id,
            },
        })
    }
}
